import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'coupon',
    serviceName: 'auth',
    query: gql`
      query coupon($ids: [String], $for_admin: Int) {
        coupon(ids: $ids, for_admin: $for_admin) {
          data {
            shop {
              id
              title
            }
            products_shop {
              id
              shop {
                id
                title
              }
              product_info {
                id
                title
                barcode
                media {
                  full_url
                }
              }
            }
            product_categories {
              id
              title
              media {
                full_url
              }
            }
          }
        }
      }
    `,
  },
};

export default schema;
